// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gWS-V","body":"styles_body__OH8sc","footer":"styles_footer__I7W--"};